module.exports = "<div class=loading-component-cover></div> <div class=loading-component-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/loading/loading.html
// module id = 1912
// module chunks = 50